export default {
  // 播放动画
  playEffect (dom, animateType, animate) {
    // 其余动画
    $(dom).addClass('jz_animate_go').delay(600).queue(function(next){
      $(this).removeClass('jz_animate_go')
      next()
    })

    // 放大特效2
    $(dom).find('.jz_photo_scale_normal2')
    .css({animation: '0.6s ease 0s 1 normal none running elasticLarge'}).delay(600).queue(function(next){
      $(this).css({animation: '0s ease 0s 1 normal none running none'})
      next()
    })

    // 边框特效1
    if (animateType === 'image_animation' && animate.id === 2 && animate.formData.effect === 0) {
      this.type2effect0Enter(dom, animate)
      setTimeout(() => {
        this.type2effect0Leave(dom, animate)
      }, 800)
    }
    // 边框特效2
    if (animateType === 'image_animation' && animate.id === 2 && animate.formData.effect === 1) {
      this.type2effect1Enter(dom, animate)
      setTimeout(() => {
        this.type2effect1Leave(dom)
      }, 800)
    }
    // 边框特效3
    if (animateType === 'image_animation' && animate.id === 2 && animate.formData.effect === 2) {
      this.type2effect2Enter(dom, animate)
      setTimeout(() => {
        this.type2effect2Leave(dom)
      }, 800)
    }
    // 边框特效4
    if (animateType === 'image_animation' && animate.id === 2 && animate.formData.effect === 3) {
      this.type2effect3Enter(dom, animate)
      setTimeout(() => {
        this.type2effect3Leave(dom)
      }, 800)
    }
    // 放大镜特效
    if (animateType === 'image_animation' && animate.id === 5) {
      this.type5effect0Enter(dom)
      setTimeout(() => {
        this.type5effect0Leave(dom)
      }, 800)
    }
  },
  // 放大特效1
  type1effect0 (dom) {
    $(dom).find('.animationImg').addClass('jz_photo_scale_normal')
  },
  // 放大特效2
  type1effect1 (dom) {
    $(dom).find('.animationImg').addClass('jz_photo_scale_normal2')
  },
  // 清除放大特效
  clearType1 (dom) {
    $(dom).removeClass('jz_animate_go')
    $(dom).find('.animationImg').removeClass('jz_photo_scale_normal')
    $(dom).find('.animationImg').removeClass('jz_photo_scale_normal2')
  },
  // 边框特效1
  type2effect0 (dom) {
    $(dom).addClass('jz_photo_border_effect_0')
  },
  type2effect0Enter (dom, img_effects) {
    let maxWidth = $(dom).find('.animationImg').width()
    let maxHeight = $(dom).find('.animationImg').height()
    // 没有边框DOM就创建
    let borderTop = ''
    let borderRight = ''
    let borderBottom = ''
    let borderLeft = ''
    if ($(dom).find('.jz_border_effect_top').length === 0) {
      borderTop = document.createElement('div')
      $(borderTop).addClass('jz_border_effect_top')
      $(dom).find('.animationImg').parent().append(borderTop)
    }
    if ($(dom).find('.jz_border_effect_right').length === 0) {
      borderRight = document.createElement('div')
      $(borderRight).addClass('jz_border_effect_right')
      $(dom).find('.animationImg').parent().append(borderRight)
    }
    if ($(dom).find('.jz_border_effect_bottom').length === 0) {
      borderBottom = document.createElement('div')
      $(borderBottom).addClass('jz_border_effect_bottom')
      $(dom).find('.animationImg').parent().append(borderBottom)
    }
    if ($(dom).find('.jz_border_effect_left').length === 0) {
      borderLeft = document.createElement('div')
      $(borderLeft).addClass('jz_border_effect_left')
      $(dom).find('.animationImg').parent().append(borderLeft)
    }
    if (img_effects.formData.border.radio_val === 'custom') {
      $(dom).find('.jz_border_effect_top').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_right').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_bottom').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_left').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
    }
    $(dom).find('.jz_border_effect_top').stop().animate({width: maxWidth + 'px'}, 300)
    $(dom).find('.jz_border_effect_right').stop().animate({height: maxHeight + 'px'}, 300)
    $(dom).find('.jz_border_effect_bottom').stop().animate({width: maxWidth + 'px'}, 300)
    $(dom).find('.jz_border_effect_left').stop().animate({height: maxHeight + 'px'}, 300)
  },
  type2effect0Leave (dom) {
    $(dom).find('.jz_border_effect_top').stop().animate({width: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_right').stop().animate({height: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_bottom').stop().animate({width: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_left').stop().animate({height: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
  },
  // 边框特效2
  type2effect1 (dom) {
    $(dom).addClass('jz_photo_border_effect_1')
  },
  type2effect1Enter (dom, img_effects) {
    let maxWidth = $(dom).find('.animationImg').width()
    let maxHeight = $(dom).find('.animationImg').height()
    // 没有边框DOM就创建
    let borderTop = ''
    let borderRight = ''
    let borderBottom = ''
    let borderLeft = ''
    if ($(dom).find('.jz_border_effect_top').length === 0) {
      borderTop = document.createElement('div')
      $(borderTop).addClass('jz_border_effect_top')
      $(borderTop).css({left: maxWidth / 2 + 'px'})
      $(dom).find('.animationImg').parent().append(borderTop)
    }
    if ($(dom).find('.jz_border_effect_right').length === 0) {
      borderRight = document.createElement('div')
      $(borderRight).addClass('jz_border_effect_right')
      $(borderRight).css({top: maxWidth / 2 + 'px'})
      $(dom).find('.animationImg').parent().append(borderRight)
    }
    if ($(dom).find('.jz_border_effect_bottom').length === 0) {
      borderBottom = document.createElement('div')
      $(borderBottom).addClass('jz_border_effect_bottom')
      $(borderBottom).css({left: maxWidth / 2 + 'px'})
      $(dom).find('.animationImg').parent().append(borderBottom)
    }
    if ($(dom).find('.jz_border_effect_left').length === 0) {
      borderLeft = document.createElement('div')
      $(borderLeft).addClass('jz_border_effect_left')
      $(borderLeft).css({top: maxWidth / 2 + 'px'})
      $(dom).find('.animationImg').parent().append(borderLeft)
    }
    if (img_effects.formData.border.radio_val === 'custom') {
      $(dom).find('.jz_border_effect_top').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_right').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_bottom').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_left').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
    }
    $(dom).find('.jz_border_effect_top').stop().animate({ width: maxWidth + 'px', left: 0 }, 300)
    $(dom).find('.jz_border_effect_right').stop().animate({ height: maxHeight + 'px', top: 0 }, 300)
    $(dom).find('.jz_border_effect_bottom').stop().animate({ width: maxWidth + 'px', left: 0 }, 300)
    $(dom).find('.jz_border_effect_left').stop().animate({ height: maxHeight + 'px', top: 0 }, 300)
  },
  type2effect1Leave (dom) {
    let maxWidth = $(dom).find('.animationImg').width()
    let maxHeight = $(dom).find('.animationImg').height()
    $(dom).find('.jz_border_effect_top').stop().animate({ width: 0 + 'px', left: maxWidth / 2 + 'px' }, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_right').stop().animate({ height: 0 + 'px', top: maxHeight / 2 + 'px' }, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_bottom').stop().animate({ width: 0 + 'px', left: maxWidth / 2 + 'px' }, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_left').stop().animate({ height: 0 + 'px', top: maxHeight / 2 + 'px' }, 300, function () {
      $(this).remove()
    })
  },
  // 边框特效3
  type2effect2 (dom) {
    $(dom).addClass('jz_photo_border_effect_2')
  },
  type2effect2Enter (dom, img_effects) {
    let maxWidth = $(dom).find('.animationImg').width()
    let maxHeight = $(dom).find('.animationImg').height()
    // 没有边框DOM就创建
    let borderTop = ''
    let borderRight = ''
    let borderBottom = ''
    let borderLeft = ''
    if ($(dom).find('.jz_border_effect_top').length === 0) {
      borderTop = document.createElement('div')
      $(borderTop).addClass('jz_border_effect_top')
      $(borderTop).css({ top: 0, left: 0 })
      $(dom).find('.animationImg').parent().append(borderTop)
    }
    if ($(dom).find('.jz_border_effect_right').length === 0) {
      borderRight = document.createElement('div')
      $(borderRight).addClass('jz_border_effect_right')
      $(borderRight).css({ top: 0, right: 0 })
      $(dom).find('.animationImg').parent().append(borderRight)
    }
    if ($(dom).find('.jz_border_effect_bottom').length === 0) {
      borderBottom = document.createElement('div')
      $(borderBottom).addClass('jz_border_effect_bottom')
      $(borderBottom).css({ right: 0, bottom: 0 })
      $(dom).find('.animationImg').parent().append(borderBottom)
    }
    if ($(dom).find('.jz_border_effect_left').length === 0) {
      borderLeft = document.createElement('div')
      $(borderLeft).addClass('jz_border_effect_left')
      $(borderLeft).css({ bottom: 0, left: 0, top: 'auto' })
      $(dom).find('.animationImg').parent().append(borderLeft)
    }
    if (img_effects.formData.border.radio_val === 'custom') {
      $(dom).find('.jz_border_effect_top').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_right').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_bottom').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_left').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
    }
    $(dom).find('.jz_border_effect_top').stop().animate({ width: maxWidth + 'px' }, 300)
    $(dom).find('.jz_border_effect_right').stop().animate({ height: maxHeight + 'px' }, 300)
    $(dom).find('.jz_border_effect_bottom').stop().animate({ width: maxWidth + 'px' }, 300)
    $(dom).find('.jz_border_effect_left').stop().animate({ height: maxHeight + 'px' }, 300)
  },
  type2effect2Leave (dom) {
    $(dom).find('.jz_border_effect_top').stop().animate({width: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_right').stop().animate({height: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_bottom').stop().animate({width: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_left').stop().animate({height: 0 + 'px'}, 300, function () {
      $(this).remove()
    })
  },
  // 边框特效4
  type2effect3 (dom) {
    $(dom).addClass('jz_photo_border_effect_3')
  },
  type2effect3Enter (dom, img_effects) {
    let maxWidth = $(dom).find('.animationImg').width()
    let maxHeight = $(dom).find('.animationImg').height()
    // 没有边框DOM就创建
    let borderTop = ''
    let borderRight = ''
    let borderBottom = ''
    let borderLeft = ''
    if ($(dom).find('.jz_border_effect_top').length === 0) {
      borderTop = document.createElement('div')
      $(borderTop).addClass('jz_border_effect_top')
      $(borderTop).css({ width: maxWidth + 'px', opacity: 0 })
      $(dom).find('.animationImg').parent().append(borderTop)
    }
    if ($(dom).find('.jz_border_effect_right').length === 0) {
      borderRight = document.createElement('div')
      $(borderRight).addClass('jz_border_effect_right')
      $(borderRight).css({ height: maxHeight + 'px', opacity: 0 })
      $(dom).find('.animationImg').parent().append(borderRight)
    }
    if ($(dom).find('.jz_border_effect_bottom').length === 0) {
      borderBottom = document.createElement('div')
      $(borderBottom).addClass('jz_border_effect_bottom')
      $(borderBottom).css({ width: maxWidth + 'px', opacity: 0 })
      $(dom).find('.animationImg').parent().append(borderBottom)
    }
    if ($(dom).find('.jz_border_effect_left').length === 0) {
      borderLeft = document.createElement('div')
      $(borderLeft).addClass('jz_border_effect_left')
      $(borderLeft).css({ height: maxHeight + 'px', opacity: 0 })
      $(dom).find('.animationImg').parent().append(borderLeft)
    }
    if (img_effects.formData.border.radio_val === 'custom') {
      $(dom).find('.jz_border_effect_top').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_right').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_bottom').css({
        height: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
      $(dom).find('.jz_border_effect_left').css({
        width: img_effects.formData.border[img_effects.formData.border.radio_val].borderWidth,
        background: img_effects.formData.border[img_effects.formData.border.radio_val].borderColor
      })
    }
    $(dom).find('.jz_border_effect_top').stop().animate({ width: `${maxWidth - 20}px`, top: '10px', left: '10px', opacity: 1 }, 300)
    $(dom).find('.jz_border_effect_right').stop().animate({ height: `${maxHeight - 20}px`, right: '10px', top: '10px', opacity: 1 }, 300)
    $(dom).find('.jz_border_effect_bottom').stop().animate({ width: `${maxWidth - 20}px`, bottom: '10px', left: '10px', opacity: 1 }, 300)
    $(dom).find('.jz_border_effect_left').stop().animate({ height: `${maxHeight - 20}px`, left: '10px', top: '10px', opacity: 1 }, 300)
  },
  type2effect3Leave (dom) {
    let maxWidth = $(dom).find('.animationImg').width()
    let maxHeight = $(dom).find('.animationImg').height()
    $(dom).find('.jz_border_effect_top').stop().animate({ width: `${maxWidth}px`, top: 0, left: 0, opacity: 0 }, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_right').stop().animate({ height: `${maxHeight}px`, right: 0, top: 0, opacity: 0 }, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_bottom').stop().animate({ width: `${maxWidth}px`, bottom: 0, left: 0, opacity: 0 }, 300, function () {
      $(this).remove()
    })
    $(dom).find('.jz_border_effect_left').stop().animate({ height: `${maxHeight}px`, left: 0, top: 0, opacity: 0 }, 300, function () {
      $(this).remove()
    })
  },
  // 移除边框特效
  clearType2 (dom) {
    $(dom).removeClass('jz_photo_border_effect_0')
    $(dom).removeClass('jz_photo_border_effect_1')
    $(dom).removeClass('jz_photo_border_effect_2')
    $(dom).removeClass('jz_photo_border_effect_3')
    $(dom).find('.jz_border_effect_top').remove()
    $(dom).find('.jz_border_effect_right').remove()
    $(dom).find('.jz_border_effect_bottom').remove()
    $(dom).find('.jz_border_effect_left').remove()
  },
  // 位移特效1
  type3effect0 (dom) {
    $(dom).find('.animationImg').addClass('jz_photo_scale')
    $(dom).addClass('jz_photo_direction_left')
  },
  // 位移特效2
  type3effect1 (dom) {
    $(dom).find('.animationImg').addClass('jz_photo_scale')
    $(dom).addClass('jz_photo_direction_right')
  },
  // 位移特效3
  type3effect2 (dom) {
    $(dom).find('.animationImg').addClass('jz_photo_scale')
    $(dom).addClass('jz_photo_direction_top')
  },
  // 位移特效4
  type3effect3 (dom) {
    $(dom).find('.animationImg').addClass('jz_photo_scale')
    $(dom).addClass('jz_photo_direction_bottom')
  },
  // 移除位移特效
  clearType3 (dom) {
    $(dom).removeClass('jz_photo_direction_left')
    $(dom).removeClass('jz_photo_direction_right')
    $(dom).removeClass('jz_photo_direction_top')
    $(dom).removeClass('jz_photo_direction_bottom')
    $(dom).find('.animationImg').removeClass('jz_photo_scale')
  },
  // 缩小特效1
  type4effect0 (dom, img_effects) {
    $(dom).find('.animationImg').addClass('jz_photo_small_effect_0')
    if (img_effects.formData.background.radio_val === 'custom') {
      $(dom).addClass('effect_background_box')
      let maskDOM = document.createElement('div')
      $(maskDOM).attr('class', 'effect_background')
      $(maskDOM).css({
        background: img_effects.formData.background[img_effects.formData.background.radio_val].color
      })
      $(dom).find('.animationImg').parent().append(maskDOM)
    }
    if (img_effects.formData.background.radio_val === 'default') {
      $(dom).removeClass('effect_background_box')
      $(dom).remove('.effect_background')
    }
  },
  // 缩小特效2
  type4effect1 (dom, img_effects) {
    $(dom).find('.animationImg').addClass('jz_photo_small_effect_1')
    if (img_effects.formData.background.radio_val === 'custom') {
      $(dom).addClass('effect_background_box')
      let maskDOM = document.createElement('div')
      $(maskDOM).attr('class', 'effect_background')
      $(maskDOM).css({
        background: img_effects.formData.background[img_effects.formData.background.radio_val].color
      })
      $(dom).find('.animationImg').parent().append(maskDOM)
    }
    if (img_effects.formData.background.radio_val === 'default') {
      $(dom).removeClass('effect_background_box')
      $(dom).remove('.effect_background')
    }
  },
  // 移除缩小特效
  clearType4 (dom) {
    $(dom).removeClass('effect_background_box')
    $(dom).find('.effect_background').remove()
    $(dom).find('.animationImg').removeClass('jz_photo_small_effect_0')
    $(dom).find('.animationImg').removeClass('jz_photo_small_effect_1')
  },
  // 放大镜特效
  type5effect0 (dom) {
    let maskDOM = document.createElement('div')
    $(maskDOM).attr('class', 'jz_photo_layer_amimate')
    let iconDOM = document.createElement('i')
    $(iconDOM).attr('class', 'iconfont icon-fangdajing')
    $(maskDOM).append(iconDOM)
    $(dom).find('.animationImg').parent().append(maskDOM)
  },
  type5effect0Enter (dom) {
    if ($(dom).find('.jz_photo_layer_amimate').length <= 0) {
      this.type5effect0(dom)
    }
    let maxHeight = $(dom).find('.animationImg').height()
    $(dom).find('.jz_photo_layer_amimate').stop().animate({ height: `${maxHeight}px`, opacity: 1 }, 300)
  },
  type5effect0Leave (dom) {
    $(dom).find('.jz_photo_layer_amimate').stop().animate({ height: 0, opacity: 0 }, 300)
  },
  // 移除放大镜特效
  clearType5 (dom) {
    $(dom).find('.jz_photo_layer_amimate').remove()
  },
  // 移除所有特效
  clearAll (dom) {
    this.clearType1(dom)
    this.clearType2(dom)
    this.clearType3(dom)
    this.clearType4(dom)
    this.clearType5(dom)
  }
}


// WEBPACK FOOTER //
// ./src/base/imgEffects.js